var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 360,
    viewBox: "0 0 406 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 376,
    height: 360,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 166,
    width: 28,
    height: 154,
    rx: 14,
    fill: "#F2F2F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 108.28,
    rx: 14,
    transform: "matrix(0.999999 0.00164756 -0.00283044 0.999996 136.93 211.672)",
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 153,
    width: 28,
    height: 167,
    rx: 14,
    fill: "#C2EACD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 166,
    width: 28,
    height: 154,
    rx: 14,
    fill: "#09AB37",
    fillOpacity: 0.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 52,
    width: 28,
    height: 268,
    rx: 14,
    fill: "#09AB37",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M4 263.712C76 257.528 63.1222 202.823 124.5 202.823C154.5 202.823 180.5 242 236 239.5C305 236.392 392 63 392 63",
    stroke: "#7557D3",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .path {\n      stroke-dasharray: 1000;\n      stroke-dashoffset: 1000;\n      animation: dash 3s 7s linear infinite alternate;\n    }\n\n    @keyframes dash {\n      to {\n        stroke-dashoffset: 0;\n      }\n    }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGraph);
export default __webpack_public_path__ + "static/media/hero-graph.fa9972266fa9ef8478c8506b29606d0f.svg";
export { ForwardRef as ReactComponent };